import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import { pinia } from '@/modules/pinia'
import 'vuetify/dist/vuetify.min.css'

import { ComponentLibrary, useEventsBus } from '@haskoning/vue-component-library'

import vuetify from './plugins/vuetify'
import router from './router'
import App from './App.vue'
import 'vuetify/dist/vuetify.min.css'
import HeaderImage from '/header.jpeg'
import HeaderImageLazy from '/header_lazy.jpg'

import { useApi } from '@/api/useApi'
import apiUrls from '@/api/apiUrls'
import { useAuthenticationStore } from '@/stores/authentication'
import { AuthenticationManagement } from '@haskoning/vue-authentication-middleware'
import { useSentryFeedback } from './composables/useSentryFeedback'

const api = useApi()
const { bus } = useEventsBus()

pinia.use(({ store }) => {
	store.$api = api
	store.$apiUrls = apiUrls
})

const app = createApp(App).use(vuetify).use(pinia).use(router)

const authStore = useAuthenticationStore(pinia)
app
	.use(AuthenticationManagement, {
		appTitle: 'Liquefaction',
		headerImage: HeaderImage,
		headerImageLazy: HeaderImageLazy,
		authStore: authStore,
		apiBaseUrl: import.meta.env.VITE_APP_API_BASE_URL.replace(/\/$/, ''),
		useLegacyAuthentication: true
	})
	.use(ComponentLibrary, { externalBus: bus })

Sentry.init({
  app,
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracePropagationTargets: ['*'],
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      triggerLabel: 'Feedback',
      formTitle: 'Send Feedback',
      submitButtonLabel: 'Send Feedback',
      cancelButtonLabel: 'Cancel',
      messagePlaceholder: 'What would you like to tell us?',
      successMessageText: 'Thank you for your feedback!',
      colorScheme: 'light',
      showName: true,
      showEmail: true,
      enableScreenshot: true,
      autoInject: false
    })
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, // Capture 10% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in cloud and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.mount('#app')

router.isReady().then(() => {
  useSentryFeedback()
})

export default app